var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"ncp_tbl grid grid_v2"},[_c('ncp-col-group',{attrs:{"data":_vm.colWidthOption}}),_c('ncp-table-body',{attrs:{"tbodyHeadData":_vm.tbodyHeadData,"tbodyContentData":_vm.tbodyContentData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }